(function($) {
    $(window).on('click', function() {
        $('.custom-select').removeClass('open');
    });

    $('select').each(function() {
        let thisSelect = this;
    
        $(thisSelect).hide();
    
        const selectOptions = thisSelect.options;
    
        const id = 'select-' + Math.floor((Math.random() * 100) + 1);
    
        let customSelect = '<div class="custom-select" id="' + id + '"><div class="fake-select">' + selectOptions[thisSelect.selectedIndex].text + '</div><div class="select-options-tray">';
    
        for(var i = 0; i < selectOptions.length; i++) {
            customSelect += '<div class="custom-select-option" data-value="' + thisSelect[i].value + '">' + thisSelect[i].text + '</div>'; 
        }
    
        customSelect += '</div></div>';
    
        $(thisSelect).after(customSelect);
    
        $('#' + id).on('click', function(e) {
            e.stopPropagation();

            if($(this).hasClass('open')) {
                $(this).removeClass('open');
            }
            else {
                $(this).addClass('open');
            }
        });
    
        $('#' + id + ' .custom-select-option').on('click', function() {
            var _this = $(this);
    
            $('#' + id).find('.fake-select').text(_this.text());
    
            $('#' + id).find('.selected').removeClass('selected');
    
            _this.addClass('selected');
    
            $(thisSelect).find('option:selected').attr('selected', false);
    
            $(thisSelect).find('option[value=' + _this.data('value') + ']').attr('selected', true);
        });
    });

    $('.icon-image-cta').on('click', function() {
        const link = $(this).data('link');
        
        if(link.length) {
            if (link.indexOf("http://") == 0 || link.indexOf("https://") == 0) {
                window.open(link, '_blank'); 
            }
            else {
                window.open(window.location.origin + link, '_self'); 
            }
        }
    });
    
    $('.text-slide-tab').on('click', function() {
        const _parent = $(this).parent();
        const grandparent_id =  _parent.data('parent');
        const grandparent = $('#' + grandparent_id);
    
        grandparent.find('.active').removeClass('active');
    
        $(this).addClass('active');
        $(grandparent).find('.text-slider-photos .text-slide-image--' + $(this).data('slide-index')).addClass('active');
    });
    
    $('.share-copy').on('click', function (e) {
        e.preventDefault();
        if($(this).hasClass('share-rss-copy')) {
            copyToClipboard(window.location + '/feed');
        }
        else {
            copyToClipboard(window.location);
        }
    
        setTimeout(function() {
            $(e.target).closest('.share-copy').tooltip('hide');
        }, 1000);
    });
    
    $('.share-twitter').on('click', function (e) {
        e.preventDefault();
        var title = $('h1').text();
        OpenShareUrl('https://twitter.com/intent/tweet?url=' + encodeURIComponent(window.location) + '&text=' + encodeURIComponent(title));
    });
    
    $('.share-facebook').on('click', function (e) {
        e.preventDefault();
        OpenShareUrl('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(window.location));
    });
    
    $('.share-linkedin').on('click', function (e) {
        var title = $('h1').text();
    
        e.preventDefault();
        OpenShareUrl('https://www.linkedin.com/shareArticle?mini=true&url=' +  encodeURIComponent(window.location) + '&title=' + encodeURIComponent(title));
    });

    $('.readmore-team').on('click', function() {
        let readMoreContent = $(this).parents('.team-box').find('.readmore-content');

        if(readMoreContent.hasClass('hide')) {
            readMoreContent.removeClass('hide');
            $(this).text('Read Less');
        } else {
            readMoreContent.addClass('hide');
            $(this).text('Read More');
        }
    });
    
    $('.blog_loadmore').on('click', function(){
    
        var button = $(this),
            data = {
                'action': 'loadmore',
                'query': window.object_name.posts, // that's how we get params from wp_localize_script() function
                'page' : window.object_name.current_page
            };
    
        $.ajax({ // you can also use $.post here
            url : window.object_name.ajaxurl, // AJAX handler
            data : data,
            type : 'POST',
            beforeSend : function (  ) {
                button.text('Loading...'); // change the button text, you can also add a preloader image
            },
            success : function( data ){
                if( data ) {
                    button.text( 'Load More' ); // insert new posts
                    $('.posts-grid').append(data.output);
                    window.object_name.current_page++;
    
    
                    if ( window.object_name.current_page == window.object_name.max_page )
                        button.remove(); // if last page, remove the button
    
                    // you can also fire the "post-load" event here if you use a plugin that requires it
                    // $( document.body ).trigger( 'post-load' );
                } else {
                    button.remove(); // if no data, remove the button as well
                }
            }
        });
    });
    $('.tab-label').on('click', function() {
        $(this).siblings('.active').removeClass('active');
        $(this).addClass('active');
        
        let target = $(this).data('content-part');
        let scrollPos = $('#' + target).offset().top;

        $('html, body').animate({ // animate your right div
            scrollTop: scrollPos - 100 // to the position of the target 
        }, 400); 
    });

    $.fn.isInViewport = function() {
        let elementTop = $(this).offset().top;
        let viewportTop = $(window).scrollTop();
        let viewportBottom = viewportTop + $(window).height() / 3;
        
        return elementTop < viewportBottom;
    };

    $('.tab-groups-content-single').each(function() {
        let _this = $(this);
        let id = _this.attr('id');

        $(window).on('resize scroll', function() {
            if(_this.isInViewport()) {
                $('.tab-label').removeClass('active');

                $('.tab-label[data-content-part="' + id + '"]').addClass('active');
            }
        })
    });
})(jQuery);



function copyToClipboard(text) {
    if (window.clipboardData && window.clipboardData.setData) {

        // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
        return window.clipboardData.setData('Text', text);
    }
    else if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
        var textarea = document.createElement('textarea');
        textarea.textContent = text;
        textarea.style.position = 'fixed';  // Prevent scrolling to bottom of page in Microsoft Edge.
        document.body.appendChild(textarea);
        textarea.select();
        try {
            return document.execCommand('copy');  // Security exception may be thrown by some browsers.
        }
        catch (ex) {
            console.warn('Copy to clipboard failed.', ex);
            return false;
        }
        finally {
            document.body.removeChild(textarea);
        }
    }
}

function OpenShareUrl(openLink){
    var winWidth    = 650;
    var winHeight   = 450;
    var winLeft     = ($(window).width()  - winWidth)  / 2,
        winTop  = ($(window).height() - winHeight) / 2,
        winOptions   = 'width='  + winWidth  + ',height=' + winHeight + ',top='    + winTop    + ',left='   + winLeft;

    window.open(openLink,'Share This Link', winOptions);
    return false;
}
 